import '../styles/main.scss';

import React, { createContext, useMemo } from 'react';
import { Routing } from '../routing';
import { GreetingModel } from '../../../../types/app/index';

interface ContextType {
  greeting?: GreetingModel;
  greetings?: GreetingModel[];
}

export const InitialContext = createContext<ContextType>(null);

export function App({ initialData }) {
  const value = useMemo(() => initialData, [initialData]);

  return (
    <InitialContext.Provider value={value}>
      <Routing />
    </InitialContext.Provider>
  );
}

export default App;
